import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

export function Spinner({ className }: { className?: string }) {
  return (
    <Loader2
      data-slot="spinner"
      aria-hidden="true"
      className={cn("animate-spin", className)}
    />
  );
}
